import { buildProjectTypeOption } from '@witmetrics/unison-core';
import { UNISON_PROJECT_TYPES } from '@witmetrics/utils/constants';

export const PROJECT_TYPE_OPTIONS = Object.values(UNISON_PROJECT_TYPES).map(
  buildProjectTypeOption
);
